export const blocklyKo = {
  CATEGORY_AUDIO: '오디오',
  CATEGORY_LED: 'LED',
  CATEGORY_DISPLAY: '화면',
  CATEGORY_MOTOR: '모터',
  CATEGORY_SENSOR: '관찰',
  CATEGORY_START: '이벤트',
  CATEGORY_CONTROL: '제어',
  CATEGORY_LOGIC: '논리',
  CATEGORY_MATH: '계산',
  CATEGORY_LIST: '목록',
  CATEGORY_TEXT: '문자열',
  CATEGORY_IFZERO: 'iFZero',
  CATEGORY_IFLINE: 'iFLine',
  CATEGORY_MACHINE: '기계',
  CATEGORY_VARIABLE: '변수',
  CATEGORY_FUNCTION: '함수',

  CUSTOM_START_ON_BOOT: '%1 시작하면 실행 %2 하기 %3',
  CUSTOM_START_ON_BOOT_TOOLTIP: '시작하면 실행',
  CUSTOM_MACHINE_IFCONTROL: '%1 %2 키를 %4 면 실행 %3 하기 %6 %5',
  CUSTOM_MACHINE_IFCONTROL_V_ALL_BUTTONS: '모든 버튼',
  CUSTOM_MACHINE_IFCONTROL_V_UP: '위',
  CUSTOM_MACHINE_IFCONTROL_V_DOWN: '아래',
  CUSTOM_MACHINE_IFCONTROL_V_LEFT: '왼쪽',
  CUSTOM_MACHINE_IFCONTROL_V_RIGHT: '오른쪽',
  CUSTOM_MACHINE_IFCONTROL_V_ALL_ARROWS: '모든 방향',
  CUSTOM_MACHINE_IFCONTROL_V_PRESSED: '누르',
  CUSTOM_MACHINE_IFCONTROL_V_RELEASED: '떼',
  CUSTOM_MACHINE_IFCONTROL_TOOLTIP: 'iFControl 키를 누르거나 떼면 실행',
  CUSTOM_MACHINE_PIN: '%2 모드의 디지털 %1 번 핀',
  CUSTOM_MACHINE_PIN_V_PIN_OUT: '핀.출력',
  CUSTOM_MACHINE_PIN_V_PIN_IN: '핀.입력',
  CUSTOM_MACHINE_PIN_SET: '디지털 핀 %1 에 %2 를 쓰기',

  CUSTOM_MACHINE_IFZERO_LED: '%1 LED %2',
  CUSTOM_MACHINE_IFZERO_LED_ON: '켜기',
  CUSTOM_MACHINE_IFZERO_LED_OFF: '끄기',
  CUSTOM_MACHINE_IFZERO_LED_TOOLTIP: 'iFZero LED 켜기/끄기',
  CUSTOM_MACHINE_IFZERO_BUTTON: '%1 버튼을 %2면 실행 %3 하기 %4',
  CUSTOM_MACHINE_IFZERO_BUTTON_V_PRESSED: '누르',
  CUSTOM_MACHINE_IFZERO_BUTTON_V_RELEASED: '떼',
  CUSTOM_MACHINE_IFZERO_BUTTON_TOOLTIP: 'iFZero 버튼을 누르거나 떼면 실행',

  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON:
    '%1 %2 핀의 gpio 버튼을 %3면 실행 %4 하기 %5',
  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON_V_PRESSED: '누르',
  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON_V_RELEASED: '떼',
  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON_TOOLTIP:
    'iFZero gpio 버튼을 누르거나 떼면 실행',

  CUSTOM_MACHINE_IFZERO_BMP_GET: '%1 BMP388 %2 센서 값',
  CUSTOM_MACHINE_IFZERO_BMP_GET_V_PRESSURE: '기압',
  CUSTOM_MACHINE_IFZERO_BMP_GET_V_TEMPERATURE: '온도',
  CUSTOM_MACHINE_IFZERO_BMP_GET_V_ALTITUDE: '고도',
  CUSTOM_MACHINE_IFZERO_BMP_GET_TOOLTIP:
    'iFZero BMP388 기압, 온도, 고도 센서 값 읽어오기',
  CUSTOM_MACHINE_IFZERO_MPU_GET: '%1 MPU9250 %2 센서 값',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_POSE: '자세',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_ACCELERATION: '가속',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_GYRO: '회전',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_MAGNETIC: '자기장',
  CUSTOM_MACHINE_IFZERO_MPU_GET_TOOLTIP:
    'iFZero MPU9250 가속, 회전, 자기장 센서 값 읽어오기',

  CUSTOM_MACHINE_IFZERO_RGBLED_PIN:
    '%1 삼색 LED %2 에 빨간색 %3 핀, 녹색 %4 핀, 파란색 %5 핀으로 지정하기',
  CUSTOM_MACHINE_IFZERO_RGBLED_PIN_TOOLTIP: 'iFZero 삼색 LED에 핀 지정하기',
  CUSTOM_MACHINE_IFZERO_RGBLED: '%1 삼색 LED %3 에 %2 지정하기',
  CUSTOM_MACHINE_IFZERO_RGBLED_TOOLTIP: 'iFZero 삼색 LED에 색 지정하기',
  CUSTOM_MACHINE_IFZERO_PHOTORESISTOR: '%1 %2 핀에서 조도센서 값',
  CUSTOM_MACHINE_IFZERO_PHOTORESISTOR_TOOLTIP: 'iFZero 조도 센서 값 읽어오기',
  CUSTOM_MACHINE_IFZERO_BUZZER: '%1 버저 듀티 %3, 주파수 %4를 %2 핀에 지정하기',
  CUSTOM_MACHINE_IFZERO_BUZZER_TOOLTIP: 'iFZero 버저 울리기',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC:
    '%1 %2 번, TRIG %3 핀, ECHO %4 핀의 %5 초음파 센서 값',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC_TOOLTIP: 'iFZero 초음파 센서값 읽어오기',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC_V_NORMAL: '일반',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC_V_FILTERED: '필터된',
  CUSTOM_MACHINE_IFZERO_LCD_PIN:
    '%1 LCD에 RS %2 핀, EN %3 핀, D4 %4 핀, D5 %5 핀, D6 %6 핀, D7 %7 핀, %8 열, %9 행 설정하기',
  CUSTOM_MACHINE_IFZERO_LCD_PIN_TOOLTIP: 'iFZero LCD 설정하기',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT: '%1 LCD에 %2 출력하기',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_TOOLTIP: 'iFZero LCD 출력하기',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_EXT: '%1 LCD %4 행에 %3 정렬로 %2 출력하기',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_EXT_TOOLTIP: 'iFZero LCD 출력하기',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_LEFT: '왼쪽',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_CENTER: '중앙',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_RIGHT: '오른쪽',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_EXTENTION: '확장',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL: '%1 LCD에 %2',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_TOOLTIP: 'iFZero LCD 제어하기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_CLEAR: '화면 비우기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HOME: '홈으로 이동하기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_SHOW_UNDERLINE: '밑줄 보이기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HIDE_UNDERLINE: '밑줄 숨기기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_SHOW_BLINK: '깜빡임 보이기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HIDE_BLINK: '깜빡임 숨기기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_MOVE_LEFT: '왼쪽으로 이동하기',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_MOVE_RIGHT: '오른쪽으로 이동하기',
  CUSTOM_MACHINE_IFZERO_LCD_CURSOR: '%1 LCD %2 열, %3 행으로 커서 옮기기',
  CUSTOM_MACHINE_IFZERO_LCD_CURSOR_TOOLTIP: 'iFZero LCD 커서 옮기기',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_1: 'LCD 문자',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_2: '에',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_3: '출력하기',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_TOOLTIP: 'iFZero LCD 문자 출력하기',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM: '%1 %2 핀에서 %3 센서 값',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM_TOOLTIP: 'iFZero 온도 습도 센서 값 읽어오기',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM_V_TEMPERATURE: '온도',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM_V_HUMIDITY: '습도',
  CUSTOM_MACHINE_IFZERO_SERVO: '%1 서보모터 듀티 %3를 %2 핀에 지정하기',
  CUSTOM_MACHINE_IFZERO_SERVO_TOOLTIP: 'iFZero 서보모터 제어하기',

  CUSTOM_MACHINE_IFZERO_BATTERY_GET: '%1 배터리 전압 값',
  CUSTOM_MACHINE_IFZERO_BATTERY_GET_TOOLTIP: 'iFZero 배터리 전압 값',

  CUSTOM_MACHINE_IFLINE_MOTOR: '%1 %2 기',
  CUSTOM_MACHINE_IFLINE_MOTOR_FRONT: '앞으로 가',
  CUSTOM_MACHINE_IFLINE_MOTOR_BACK: '뒤로 가',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_LEFT: '좌회전 하',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_RIGHT: '우회전 하',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_REAR_LEFT: '뒤로 좌회전 하',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_REAR_RIGHT: '뒤로 우회전 하',
  CUSTOM_MACHINE_IFLINE_MOTOR_STOP: '정지하',
  CUSTOM_MACHINE_IFLINE_MOTOR_TOOLTIP:
    'iFLine 앞으로, 뒤로, 좌회전, 우회전, 정지',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED: '%1 %3 속도 %2 로 설정하기',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_BOTH: '양쪽 바퀴',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_LEFT: '왼쪽 바퀴',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_RIGHT: '오른쪽 바퀴',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_TOOLTIP: 'iFLine 속도',
  CUSTOM_MACHINE_IFLINE_DISTANCE:
    'iFLine 초음파 센서 거리가 %2 cm보다 %1 (으)면 실행 %3',
  CUSTOM_MACHINE_IFLINE_DISTANCE_SHORT: '짧',
  CUSTOM_MACHINE_IFLINE_DISTANCE_LONG: '길',
  CUSTOM_MACHINE_IFLINE_DISTANCE_TOOLTIP:
    'iFLine 초음파 센서 거리가 지정한 길이보다 짧거나 길면 실행',
  CUSTOM_MACHINE_IFLINE_DISTANCE_GET: '%1 초음파 센서 거리 값 (cm)',
  CUSTOM_MACHINE_IFLINE_LED: '%1 %3 LED를 %2 으로 지정하기',
  CUSTOM_MACHINE_IFLINE_LED_TOOLTIP: 'iFLine LED에 색 지정하기',
  CUSTOM_MACHINE_IFLINE_IR_GET: '%1 %2 IR 센서 값',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_LEFTR: '왼쪽R',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_LEFT: '왼쪽',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_RIGHT: '오른쪽',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_RIGHTR: '오른쪽R',
  CUSTOM_MACHINE_IFLINE_IR_GET_TOOLTIP:
    'iFLine 왼쪽R, 왼쪽, 오른쪽, 오른쪽R IR 센서 값',

  CUSTOM_MACHINE_IFLINE_MORTOR_IR_RESET: '%1 모터 IR 값 초기화',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_RESET_TOOLTIP: 'iFLine 모터 IR 값 초기화',

  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET: '%1 %2 모터 IR 센서 값',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_LEFT: '왼쪽',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_RIGHT: '오른쪽',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_RESET: '초기화',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_TOOLTIP:
    'iFLine 왼쪽, 오른쪽, 초기화 모터 IR 센서 값',

  CUSTOM_TIME_SLEEP: '%1 %2 기다리기',
  CUSTOM_TIME_SLEEP_SECOND: '초',
  CUSTOM_TIME_SLEEP_MILLISECOND: '밀리초',
  CUSTOM_TIME_SLEEP_MICROSECOND: '마이크로초',
  CUSTOM_TIME_SLEEP_TOOLTIP: '초, 밀리초, 마이크로초 기다리기',
  CUSTOM_COMMON_COLOR: '%1 색',
  CUSTOM_COMMON_COLOR_TOOLTIP: '색상',
  CUSTOM_COMMON_COLOR_EXT: '빨강 %2, 초록 %3, 파랑 %4 %1 색',
  CUSTOM_COMMON_COLOR_EXT_TOOLTIP: '색상'
}

export const i18nKo = {
  Login: '로그인',
  Logout: '로그아웃',
  Open: '열기',
  Save: '저장',
  Publish: '배포',
  Blocks: '블록',
  Python: '파이썬',
  Setting: '설정',
  Language: '언어',
  'iFBlock Info': 'iFBlock 정보',
  'Select Language': '언어 선택',

  Close: '닫기',
  Cancle: '취소',
  Confirm: '확인',
  'URL Edit': 'URL 수정',
  Detail: '상세',
  Back: '뒤로',
  'User Info': '사용자 정보',
  Name: '이름',
  Email: '이메일',
  'Change Password.': '비밀번호를 변경합니다.',
  'Change Password': '비밀번호 변경',
  'Leave iFBlock Service. Delete saved projects. Can not restore.':
    'iFBlock 서비스를 탈퇴합니다. 저장한 작업들도 삭제됩니다.  복구할 수 없습니다.',
  Change: '변경',
  Leave: '탈퇴',
  'New Password': '새 비밀번호',
  'Confirm New Password': '새 비밀번호 확인',
  'Confirm Leave iFBlock': 'iFBlock 탈퇴 확인',
  'Are you sure to leave?': '정말로 탈퇴합니까?',

  'Login Success!': '로그인 성공!',
  'Login Fail!': '로그인 실패!',
  'Logout Success!': '로그아웃 성공!',
  'Password Save Success!': '비밀번호 변경 성공!',
  'Leave iFBlock Success!': 'iFBlock 탈퇴 성공!',
  'Login Email verification': '로그인 이메일 인증',
  'Check your Email Verification, Verification Email takes few minutes.':
    '이메일 메일함에서 링크를 눌러 이메일 주소를 인증하세요. 인증 이메일 전송은 몇 분 정도 걸립니다.',
  'Login needs Email Verification!': '로그인하려면 이메일 인증이 필요합니다!',
  'Resend Verification Email': '인증 이메일 재전송',

  'Copyright (C) INDIFROG 2021': 'Copyright ⓒ 2021 주식회사 인디프로그.',
  'Home Page': '홈페이지',
  'Build Date': '빌드 날짜',
  'The Nanum font provided by Naver is applied to this page.':
    '이 페이지에는 네이버에서 제공한 나눔글꼴이 적용되어 있습니다.',

  'New Project': '새 작업',
  'Save As': '다른 이름으로 저장',
  'Open Project': '작업 열기',
  'My Project': '내 작업',
  'Sample Project': '예제 작업',
  'Date (Time)': '날짜 (시간)',
  Date: '날짜',
  Rename: '이름 바꾸기',
  Delete: '지우기',
  'Copy to Sample': '예제로 복사',
  'Save to Sample': '예제로 저장',
  'Save Project': '작업 저장',
  'Project Name': '작업 이름',
  'Project Duplicate': '작업 중복',
  'Project is already exist. Are you sure about saving it?':
    '작업이 이미 있습니다. 덮어 쓰겠습니까?',
  'Delete Project': '작업 지우기',
  'Are you sure to delete the project?': '작업을 지우겠습니까?',
  'Rename Project': '작업 이름 바꾸기',
  '{projectName} {messageType} Project is opened!':
    '{projectName} {messageType} 작업을 열었습니다!',
  '{projectName} {messageType} Project is saved!':
    '{projectName} {messageType} 작업을 저장했습니다!',
  '{projectName} Project is renamed!':
    '{projectName} 작업 이름을 변경했습니다!',
  '{projectName} Project is removed!': '{projectName} 작업을 삭제했습니다!',
  '{projectName} Project is copied to Sample!':
    '{projectName} 작업을 예제로 복사했습니다!',
  'Sample Project Detail': '예제 작업 상세',
  'Project URL Edit': '작업 URL 수정',
  'Image URL': '이미지 URL',
  'Youtube URL': '유투브 URL',
  'Circuit Diagram URL': '회로도 URL',
  'Youtube URL Start with': '유투브 URL은 다음으로 시작합니다',
  '{projectName} Project url is changed!':
    '{projectName} 작업 url을 저장했습니다!',
  Sample: '예제',
  My: '내',
  English: '영어',
  Korean: '한글',
  Untitled: '제목 없음',
  'Project Type': '작업 유형',
  'Device Type': '장치 유형',
  'Example Tab': '예제 탭',
  'Add Device': '장치 추가',
  Add: '추가',
  'Delete Device': '장치 지우기',
  'Are you sure to delete the device?': '장치를 지우겠습니까?',
  'Change Alert': '변경 알림',
  'Changes may not be saved.': '변경사항이 저장되지 않을 수 있습니다.',
  Help: '도움말'
}
